/**
 * Models
 * @module models
 */
define( function (require, exports) {

    'use strict';

    /**
     * @constructor
     * @ngInject
     */
    function WidgetModel(lpWidget, lpCoreUtils, $resource) {
        var utils = lpCoreUtils;
        var state = {
            title: lpWidget.getPreference('title'),
            icon: utils.resolvePortalPlaceholders(lpWidget.getPreference('thumbnailUrl')),
            localeSwitchURL: utils.resolvePortalPlaceholders(lpWidget.getPreference('localeSwitchURL')) || '/portalserver/services/rest/v1/public/language/change'

        };

        var model = {};
        /**
         * @public
         * @return {Object} current model state
         */
        model.getState = function () {
            return state;
        };

        model.localeSwitchEndPoint = $resource(state.localeSwitchURL);
        return model;
    }

    module.exports = WidgetModel;
});



//////////////////
// WEBPACK FOOTER
// ./scripts/model.js
// module id = 6
// module chunks = 0